<template>
  <v-app id="guest-registration-app">
    <v-main v-if="!$auth.ready() || !loaded">
      <v-sheet
          color="grey lighten-2"
          style="background-color: rgba(0, 0, 0, 0.87); height: 100%"
      >
        <v-skeleton-loader
            ref="skeleton"
            class="mx-auto"
            type="card-heading"
        ></v-skeleton-loader>
        <v-row style="height: auto">
          <v-col cols="2">
            <v-skeleton-loader
                ref="skeleton"
                class="mx-auto pt-3"
                type="list-item-avatar-two-line"
            ></v-skeleton-loader>
            <v-divider></v-divider>
            <v-skeleton-loader
                v-for="i in 2"
                :key="i"
                ref="skeleton"
                class="mx-auto"
                type="article, divider, actions, divider"
            ></v-skeleton-loader>
          </v-col>
          <v-col cols="10">
            <v-container fluid>
              <v-skeleton-loader
                  ref="skeleton"
                  class="mx-auto"
                  type="table, divider"
              ></v-skeleton-loader>
            </v-container>
          </v-col>
        </v-row>
      </v-sheet>
    </v-main>
    <router-view v-else />
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    loaded: process.env.VUE_APP_ENABLE || true
  }),
};
</script>
